import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	placeholderBracketHint: {
		id: 'full-page-editor.place.holder.bracket.hint',
		defaultMessage: 'Any element can be quickly inserted by typing /',
		description:
			'The placeholder text that appears in editor that already have content when user enter a new line and type {',
	},
	blogpostPermissionsNotice: {
		id: 'full-page-editor.permissions.blogpost-access',
		defaultMessage: 'Default access to this blog is now in effect.',
		description: 'Notice when selecting the blogpost blueprint to update preset access settings',
	},
	placeholderUpsellAI: {
		id: 'full-page-editor.content.placeholder.upsell.ai',
		defaultMessage:
			'Type /ai for Atlassian Intelligence, / to add elements, or @ to mention someone.',
		description:
			'The placeholder for the full page editor when AI is available as an upgrade, part of the AI in Editor experiment',
	},
});
